import Header from 'components/typography/Header'
import styles from './styles/PartnersPanel.css'
import P from 'components/typography/Paragraph'
import classNames from 'classnames'
import Link from '../misc/Link'

const defaultHeaderCopy = 'Our partners'

const defaultSubHeaderCopy = "We've partnered with leading organizations to help researchers fundamentally change the way they do research."

export const PartnersPanel = ({ header = defaultHeaderCopy, subheader = defaultSubHeaderCopy, wideLayout = false, studentEndorsements }) => {
  return (
    <div className={styles.panel}>
      {header && <Header level={2} className={styles.header}>{header}</Header>}
      {subheader && (
        <P className={styles.text}>
          {subheader}
        </P>
      )}
      {studentEndorsements && (
        <P className={styles.seeWhatStudents}>
          See what <Link blue underline to='/endorsements'>students are saying</Link>
        </P>
      )}
      <div className={classNames(styles.partnerlogo, {
        [styles.partnerlogoWide]: wideLayout
      })}
      >
        <img className={styles.img} loading='lazy' alt='rup' src={`${CONFIG.assetsBaseURL}/images/partners/rup.svg`} />
        <img className={styles.img} loading='lazy' alt='bmj' src={`${CONFIG.assetsBaseURL}/images/partners/bmj.svg`} />
        <img className={styles.img} loading='lazy' alt='krager' src={`${CONFIG.assetsBaseURL}/images/partners/krager.svg`} />
        <img className={styles.img} loading='lazy' alt='fmg' src={`${CONFIG.assetsBaseURL}/images/partners/fsg.svg`} />
        <img className={styles.img} loading='lazy' alt='wiley' src={`${CONFIG.assetsBaseURL}/images/partners/wiley.svg`} />
        <img className={styles.img} loading='lazy' alt='iop' src={`${CONFIG.assetsBaseURL}/images/partners/iop.svg`} />
        <img className={styles.img} loading='lazy' alt='cup' src={`${CONFIG.assetsBaseURL}/images/partners/cup.svg`} />
        <img className={styles.img} loading='lazy' alt='epmc' src={`${CONFIG.assetsBaseURL}/images/partners/epmc.svg`} />
        <img className={styles.img} loading='lazy' alt='mbc' src={`${CONFIG.assetsBaseURL}/images/partners/mbc.svg`} />
        <img className={styles.img} loading='lazy' alt='thieme' src={`${CONFIG.assetsBaseURL}/images/partners/thieme.svg`} />
        <img className={styles.img} loading='lazy' alt='sage' src={`${CONFIG.assetsBaseURL}/images/partners/sage.png`} />
        <img className={styles.img} loading='lazy' alt='frontiers' src={`${CONFIG.assetsBaseURL}/images/partners/frontiers.svg`} />
        <img className={styles.img} loading='lazy' alt='aps' src={`${CONFIG.assetsBaseURL}/images/partners/aps-v3.png`} />
        <img className={styles.img} loading='lazy' alt='iucr' src={`${CONFIG.assetsBaseURL}/images/partners/iucr.svg`} />
        <img className={styles.img} loading='lazy' alt='arxiv' src={`${CONFIG.assetsBaseURL}/images/partners/arxiv.png`} />
        <img className={styles.img} loading='lazy' alt='emerald' src={`${CONFIG.assetsBaseURL}/images/partners/emerald.png`} />
        <img className={styles.img} loading='lazy' alt='uhk' src={`${CONFIG.assetsBaseURL}/images/partners/uhk.png`} />
        <img className={styles.img} loading='lazy' alt='smu' src={`${CONFIG.assetsBaseURL}/images/partners/smu.png`} />
        <img className={styles.img} loading='lazy' alt='cshl' src={`${CONFIG.assetsBaseURL}/images/partners/cshl.png`} />
        <img className={styles.img} loading='lazy' alt='university-of-gavle' src={`${CONFIG.assetsBaseURL}/images/partners/university-of-gavle.png`} />
      </div>
    </div>
  )
}

export default PartnersPanel
